import React from "react";
import { CV } from "../components/cv";
import ArunRImg from "@/assets/images/arun-r.png";

export default function CVArunRathi() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Arun Rathi";
  }, []);

  return (
    <CV
      name="Arun Rathi"
      photo={ArunRImg}
      title="Senior Android Engineer"
      subtitle="Kotlin and Jetpack Compose alongside legacy Java/XML maintenance — Media3/ExoPlayer playback, multi-repo Android source trees and Jenkins pipelines."
      summary="Senior Android engineer with 15+ years of software engineering experience building high-performance, consumer-facing mobile and media applications at scale. Specialist in modern Kotlin development, Jetpack Compose, advanced audio/video playback architecture (Android Media3 / ExoPlayer) and legacy UI maintenance (Java, XML, ViewBinding, RecyclerView). Experienced in managing Android multi-repository environments with Repo, maintaining interactive API documentation via Swagger and driving CI/CD automation pipelines with Jenkins. Track record of architecting offline-first mobile systems, tuning application UI performance and maintaining >99.9% crash-free session rates for active consumer audiences. Collaborative team lead with a long history of partnering across product management, UX/UI design, backend and quality engineering to ship clean, modular codebases."
      skills={{
        "Modern Android": [
          "Kotlin",
          "Jetpack Compose",
          "Jetpack Navigation",
          "Coroutines",
          "Flow",
          "Android Jetpack",
        ],
        "Legacy UI & Maintenance": [
          "Java",
          "XML layouts",
          "ViewBinding",
          "RecyclerView",
          "Custom ViewHolders",
        ],
        "Media & Streaming": [
          "Android Media3",
          "ExoPlayer",
          "Audio focus management",
          "Background playback services",
          "Media caching",
          "Media session / lock-screen controls",
        ],
        "Architecture & APIs": [
          "Clean Architecture",
          "MVVM",
          "MVI",
          "Multi-module apps",
          "REST",
          "Retrofit",
          "Room DB",
          "Data synchronisation",
        ],
        "Performance & Quality": [
          "Android Studio Profiler",
          "Firebase Crashlytics",
          "UI latency reduction",
          "Thread synchronisation",
          "Memory & leak management",
          "Espresso",
          "JUnit",
        ],
        "Build & Tooling": ["Repo", "Jenkins", "Swagger", "CI/CD automation"],
        Languages: ["English (professional)", "Swedish (beginner)"],
      }}
      experience={[
        {
          role: "Senior Android Platform & Application Specialist",
          company: "Sony Mobile Communications AB, Lund",
          period: "2012 – 2026",
          description:
            "Android platform and application engineering across BRAVIA Smart TV media integration, premium RCS communication frameworks and Android system framework services.",
          highlights: [
            "Partnered with global product, UI/UX, backend and QA teams to build fluid layout controls optimised for large-screen media navigation.",
            "Interfaced custom UI applications with underlying Android multimedia frameworks, handling hardware-acceleration boundaries for smooth frame rates.",
            "Managed complex multi-repository Android source trees with Google Repo and integrated automated build/test pipelines with Jenkins.",
            "Led architectural discussions and clean-code standards for a team of ~10 engineers via code reviews, technical specifications and pair programming.",
            "Eliminated legacy technical debt across Java/XML UI components, ViewBinding layers and framework services to maximise runtime efficiency.",
            "Engineered low-level background services and framework optimisations for platform stability, memory efficiency and fast startup.",
            "Wrote detailed test specifications with QA and supported automated regression suites during major platform updates.",
          ],
        },
        {
          role: "Lead Android Engineer (Media Playback & Architecture)",
          company: "Bhakti Vikas Digital Platform (Google Play Store)",
          period: "2016 – 2025",
          description:
            "Independently built, tested and published a consumer-focused, offline-first media streaming and audiobook platform that grew organically to 10,000+ active users.",
          highlights: [
            "Integrated Media3 and ExoPlayer in background audio services with custom audio focus state machines, client-side caching and lock-screen media session controls.",
            "Architected native interfaces in Jetpack Compose while maintaining legacy screens built with Java, XML layouts, ViewBinding and optimised RecyclerView implementations.",
            "Connected clients to REST backends with Retrofit, Room DB caching and seamless offline-to-online playback state transitions.",
            "Maintained a >99.9% crash-free session rate with Espresso/JUnit coverage and Firebase Crashlytics monitoring.",
          ],
        },
      ]}
      education={[
        {
          degree: "Bachelor of Engineering (B.E.)",
          institution: "Computer Science & Engineering",
          year: "",
        },
      ]}
    />
  );
}
